import { Environment } from 'src/utils/Environment';

export function initializeTealium() {
  if (Environment.current.isLocalhost) return;  // Tealium should not run locally

  const currentEnv = Environment.current.environmentForTealium;

  const script = document.createElement('script');
  script.innerHTML = `(function(a,b,c,d){
    a='https://tags.tiqcdn.com/utag/firstdata/cloverwebsite/${currentEnv}/utag.js';
    b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
    a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
    })();`;
    if (document && document.head) {
      document.head.appendChild(script);
    }
}
